// Copied verbatim from `loan_purpose_options` in eastview-os app/models/pipeline.py
// (also the pricing/sizer LOAN_PURPOSE_OPTIONS), in the backend's order. Values
// are matched by string equality server-side — never reword them.
// "Delayed Purchase" is no longer an option (REQ-106, 2026-10-19): it is the
// `delayedPurchase` flag on a "Refinance - Cash Out" loan now. Legacy stored
// values are still read — see src/utils/loans/delayedPurchase.js.
export const selectOptionsLoanPurpose = [
  "Purchase",
  "Refinance - No Cash Out",
  "Refinance - Cash Out",
];
